<template>
  <div class="big booking-activity-statistics">
    <div class="page_title flex_between">
      <span>{{ routerQuery.act_name }}</span>
      <el-button type="primary"
                 style="width: 120px"
                 size="small"
                 @click="back">返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 10px 20px 20px 20px;">

        <div class="search-box">
          <!-- 用户昵称 -->
          <div class="item">
            <span>用户昵称</span>
            <div class="item-content">
              <el-input v-model="statisticsForm.nickname"
                        size="small"
                        clearable
                        @keyup.enter.native="seachEnterFun"
                        placeholder="请输入"></el-input>
            </div>
          </div>

          <!-- 用户手机号 -->
          <div class="item">
            <span style="width:80px">用户手机号</span>
            <div class="item-content">
              <el-input v-model="statisticsForm.user_phone"
                        size="small"
                        clearable
                        @keyup.enter.native="seachEnterFun"
                        placeholder="请输入"></el-input>
            </div>
          </div>

          <!-- 预约信息 -->
          <div class="item">
            <span>预约信息</span>
            <div class="item-content">
              <el-input v-model="statisticsForm.register_info"
                        size="small"
                        clearable
                        @keyup.enter.native="seachEnterFun"
                        placeholder="请输入"></el-input>
            </div>
          </div>

          <!-- 预约物品 -->
          <div class="item">
            <span>预约物品</span>
            <div class="item-content">
              <el-input v-model="statisticsForm.register_item"
                        size="small"
                        clearable
                        @keyup.enter.native="seachEnterFun"
                        placeholder="请输入"></el-input>
            </div>
          </div>

          <!-- 备注 -->
          <div class="item">
            <span>备注</span>
            <div class="item-content">
              <el-input v-model="statisticsForm.remark"
                        size="small"
                        clearable
                        @keyup.enter.native="seachEnterFun"
                        placeholder="请输入"></el-input>
            </div>
          </div>

          <!-- 处理状态 -->
          <div class="item">
            <span style="margin-left:10px">处理状态</span>
            <div class="item-content">
              <el-radio-group v-model="statisticsForm.status">
                <el-radio :label="-1">全部</el-radio>
                <el-radio :label="1">已处理</el-radio>
                <el-radio :label="0">未处理</el-radio>
              </el-radio-group>
            </div>
            <el-button type="primary"
                       size="small"
                       style="margin-left:20px"
                       @click="getList">查询</el-button>
            <el-button size="small"
                       @click="restBtn">重置</el-button>
            <span style="margin-left:50px">预约总金额：{{total_price}}元</span>
          </div>

        </div>

        <div style="border: solid 1px #c9cbd6;">
          <el-table v-loading="tableLoading"
                    :data="statisticsData"
                    tooltip-effect="dark"
                    style="width: 100%; min-width: 1000px"
                    :header-cell-style="{ background: '#F5F5F5' }"
                    @sort-change='sortChange'>
            <el-table-column v-for="item in tableHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :fixed="item.fixed"
                             :sortable="item.sortable">
              <template slot-scope="scope">
                <div v-if="item.prop == 'user_info'">
                  <div>{{ scope.row['nick_name'] }}</div>
                  <div>{{ scope.row['user_phone'] }}</div>
                </div>

                <div v-else-if="item.prop == 'pay_time'">
                  {{ scope.row[item.prop] | dateFormat }}
                </div>

                <div v-else-if="item.prop == 'pay_info'">
                  <div>
                    <span>{{ scope.row['name'] }}</span> &nbsp;
                    <span>{{ scope.row['sex'] | sexText }}</span>&nbsp;
                    <span>{{ scope.row['age'] }}</span>
                  </div>
                  <div>{{ scope.row['phone'] }}</div>
                  <div>{{ scope.row['id_card'] }}</div>
                  <div>{{ scope.row['address'] }}</div>
                </div>

                <div v-else-if="item.prop == 'pay_list'">
                  <div v-for="(val,index) in scope.row['item_list']"
                       :key="index">
                    <span>{{ val.item_name }}</span> &nbsp;
                    <span>X{{ val.num }}</span>
                  </div>
                </div>

                <div v-else-if="item.prop == 'status'">
                  {{ scope.row[item.prop] | statusText }}
                </div>
                <div v-else>
                  {{ !scope.row[item.prop] ? '' : scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column label="操作"
                             width="220"
                             align="center"
                             fixed="right">

              <template slot-scope="scope">
                <div v-if="scope.row.is_refund == 0 && scope.row.price > 0">
                  <el-button type="text"
                             @click="remarkBtn(scope.row.register_id)"
                             :disabled="module_id_array[0]?!module_id_array.includes('1405'):false">备注</el-button>
                  <el-button type="text"
                             @click="refundBtn(scope.row)"
                             :disabled="module_id_array[0]?!module_id_array.includes('1406'):false">退款</el-button>
                </div>

                <div v-if="scope.row.is_refund == 1 || scope.row.price == 0">
                  <el-button type="text"
                             @click="remarkBtn(scope.row.register_id)"
                             :disabled="module_id_array[0]?!module_id_array.includes('1405'):false">备注</el-button>
                </div>
              </template>

            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination v-show="totalNum>0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getList" />
      </div>
    </div>
    <!-- 备注 -->
    <el-dialog title="备注"
               width="600px"
               :visible.sync="dialogRemark"
               :close-on-click-modal="false"
               custom-class="cus-dialogRemark">
      <div class="content">
        <el-input type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  maxlength="100"
                  show-word-limit
                  placeholder="请输入"
                  v-model="remarkForm.remark">
        </el-input>
        <div class="cus-checkbox">
          <el-checkbox v-model="remarkForm.status"
                       :true-label="1"
                       :false-label="0">并标记为已处理</el-checkbox>
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogRemark = false"
                   size="small">取 消</el-button>
        <el-button type="primary"
                   @click="dialogRemarkConfirm"
                   size="small">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 退款 -->
    <el-dialog title="退款"
               width="600px"
               :visible.sync="dialogRefund"
               :close-on-click-modal="false"
               custom-class="cus-dialogRefund">
      <div class="content">
        <div class="price">
          您确定将当前预约{{ refundForm.price }}元退款吗？请填写退款原因。此过程不可逆，须谨慎操作。
        </div>
        <el-input type="textarea"
                  :autosize="{ minRows: 4, maxRows: 6}"
                  maxlength="100"
                  show-word-limit
                  placeholder="请输入"
                  v-model="refundForm.refund_desc">
        </el-input>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogRefund = false"
                   size="small">取 消</el-button>
        <el-button type="primary"
                   @click="dialogRefundConfirm"
                   size="small">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import _ from 'lodash';
import dayjs from 'dayjs';
import marketing from '@/api/marketing.js';
import Pagination from '@/components/Pagination/index';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      tableLoading: false,
      statisticsForm: {
        nickname: '',
        user_phone: '',
        register_info: '',
        register_item: '',
        remark: '',
        status: 0,
        sort: ''
      },
      tableHeader: [
        {
          label: '用户信息',
          prop: 'user_info',
          width: 'auto',
          align: 'center',
          fixed: 'left',
          sortable: false
        },
        {
          label: '预约时间',
          prop: 'pay_time',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: false
        },
        {
          label: '预约信息',
          prop: 'pay_info',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: false
        },
        {
          label: '预约物品信息',
          prop: 'pay_list',
          width: '200',
          align: 'center',
          fixed: false,
          sortable: false
        },
        {
          label: '预约金额',
          prop: 'price',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: 'custom'
        },
        {
          label: '备注',
          prop: 'remark',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: false
        },
        {
          label: '处理状态',
          prop: 'status',
          width: 'auto',
          align: 'center',
          fixed: false,
          sortable: false
        }
      ],
      statisticsData: [],
      total_price: 0,
      dialogRemark: false,
      remarkForm: {
        register_id: '',
        remark: '',
        status: 0
      },
      dialogRefund: false,
      refundForm: {
        register_id: '',
        refund_desc: '',
        price: ''
      }
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? '' : dayjs.unix(val).format('YYYY-MM-DD HH:mm');
    },
    sexText(val) {
      switch (val) {
        case 1:
          return '男';
        case 2:
          return '女';
        default:
          return '';
      }
    },
    statusText(val) {
      switch (val) {
        case 0:
          return '未处理';
        case 1:
          return '已处理';
      }
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routerQuery() {
      return this.$route.query;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign(this.pagination, this.statisticsForm, {
        act_id: this.routerQuery.act_id
      });
      this.tableLoading = true;
      marketing.getLogListPaging(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.statisticsData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
          this.total_price = data.total_price;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    sortChange(e) {
      let order = e.order;
      if (order == 'descending') {
        this.statisticsForm.sort = 1;
      } else if (order == 'ascending') {
        this.statisticsForm.sort = 0;
      } else {
        this.statisticsForm.sort = '';
      }
      this.getList();
    },
    // 备注
    remarkBtn(register_id) {
      this.remarkForm.register_id = register_id;
      this.remarkForm.remark = '';
      this.remarkForm.status = 0;
      this.dialogRemark = true;
    },
    dialogRemarkConfirm() {
      let params = Object.assign({}, this.remarkForm);
      marketing.saveLogRemark(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success('保存成功');
          this.dialogRemark = false;
          this.getList();
        }
      });
    },
    // 退款
    refundBtn(row) {
      let { register_id, price } = row;
      this.refundForm.refund_desc = '';
      this.refundForm.register_id = register_id;
      this.refundForm.price = price;
      this.dialogRefund = true;
    },
    dialogRefundConfirm() {
      if (this.refundForm.refund_desc == '') {
        this.$message.warning('请输入退款原因');
        return;
      }
      let params = Object.assign({}, this.refundForm);
      params = _.omit(params, ['price']);
      marketing.refundLog(params).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success('退款成功');
          this.dialogRefund = false;
          this.getList();
        }
      });
    },
    restBtn() {
      for (let key in this.statisticsForm) {
        if (key == 'status') {
          this.statisticsForm[key] = 0;
        } else {
          this.statisticsForm[key] = '';
        }
      }
      this.getList();
    },
    back() {
      history.back();
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.booking-activity-statistics {
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      margin-right: 30px;
      span {
        width: 56px;
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
      .el-radio-group {
        padding-top: 4px;
      }
    }
  }
}
.cus-dialogRemark {
  .content {
    padding: 10px;
    .cus-checkbox {
      margin-top: 10px;
      text-align: left;
    }
  }
}
.cus-dialogRefund {
  .content {
    padding: 10px;
    .price {
      margin-bottom: 10px;
    }
  }
}
</style>